export enum ImmomioIcons {
  Xing = 'xing',
  Window = 'window',
  WholeRooms = 'whole-rooms',
  Wbs = 'wbs',
  Water = 'water',
  Warning = 'warning',
  UtilityRoom = 'utility-room',
  User = 'user',
  Urinal = 'urinal',
  Upload = 'upload',
  Tv = 'tv',
  Trash = 'trash',
  Train = 'train',
  Toilet = 'toilet',
  Ticket = 'ticket',
  ThumbsUp = 'thumbs-up',
  Terrace = 'terrace',
  Tag = 'tag',
  Sun = 'sun',
  Store = 'store',
  Stairwell = 'stairwell',
  Stairs = 'stairs',
  Sorting = 'sorting',
  Skyscraper = 'skyscraper',
  Shower = 'shower',
  Share = 'share',
  Senior = 'senior',
  SearchProfile = 'search-profile',
  School = 'school',
  Reporting = 'reporting',
  Refresh = 'refresh',
  Refresh1 = 'refresh-1',
  Redirect = 'redirect',
  QuestionOutlined = 'question-outlined',
  Publish = 'publish',
  Pool = 'pool',
  Plus = 'plus',
  PlusOutlined = 'plus-outlined',
  Plug = 'plug',
  Plane = 'plane',
  Pipe = 'pipe',
  Pin = 'pin',
  PinPlaned = 'pin-planed',
  Phone = 'phone',
  Pet = 'pet',
  Pen = 'pen',
  Pdf = 'pdf',
  PaymentRequest = 'payment-request',
  PartyCannon = 'party-cannon',
  Parking = 'parking',
  PaperPlane = 'paper-plane',
  PaperClip = 'paper-clip',
  PaintRoller = 'paint-roller',
  PaintBrush = 'paint-brush',
  Office = 'office',
  Note = 'note',
  News = 'news',
  MovingBox = 'moving-box',
  MoreMoney = 'more-money',
  Monument = 'monument',
  MoneyPig = 'money-pig',
  MoneyBag = 'money-bag',
  Mobile = 'mobile',
  Minus = 'minus',
  MinusOutlined = 'minus-outlined',
  Memory = 'memory',
  Megaphone = 'megaphone',
  Masonry = 'masonry',
  Mail = 'mail',
  Magnifier = 'magnifier',
  Logout = 'logout',
  Loggia = 'loggia',
  LockOpen = 'lock-open',
  LockClosed = 'lock-closed',
  Location = 'location',
  LocationOutlined = 'location-outlined',
  List = 'list',
  Linkedin = 'linkedin',
  Link = 'link',
  Lightning = 'lightning',
  LightningOutlined = 'lightning-outlined',
  LightBulb = 'light-bulb',
  Lift = 'lift',
  Law = 'law',
  Laundry = 'laundry',
  LaundryRoom = 'laundry-room',
  Kitchen = 'kitchen',
  Keyboard = 'keyboard',
  Key = 'key',
  InternetCable = 'internet-cable',
  Intercom = 'intercom',
  Info = 'info',
  House = 'house',
  HouseDoor = 'house-door',
  Hospital = 'hospital',
  History = 'history',
  Highway = 'highway',
  Heating = 'heating',
  Handicapped = 'handicapped',
  Hammer = 'hammer',
  HalfRooms = 'half-rooms',
  Globe = 'globe',
  Gear = 'gear',
  GasContainer = 'gas-container',
  Garden = 'garden',
  Garage = 'garage',
  Food = 'food',
  Folder = 'folder',
  FolderOutlined = 'folder-outlined',
  Floor = 'floor',
  Flashes = 'flashes',
  Fireplace = 'fireplace',
  Fire = 'fire',
  Filter = 'filter',
  EyeOpen = 'eye-open',
  EyeClosed = 'eye-closed',
  Extinguisher = 'extinguisher',
  Export = 'export',
  Expand = 'expand',
  Error = 'error',
  EnergyCertificate = 'energy-certificate',
  Editor = 'editor',
  Download = 'download',
  Door = 'door',
  Document = 'document',
  Data = 'data',
  Dashboard = 'dashboard',
  Crosshair = 'crosshair',
  Crane = 'crane',
  Copy = 'copy',
  Cookie = 'cookie',
  Contract = 'contract',
  ContextMenu = 'context-menu',
  ContextMenuOutlined = 'context-menu-outlined',
  ContactList = 'contact-list',
  Computer = 'computer',
  Compass = 'compass',
  Commercial = 'commercial',
  Coin = 'coin',
  Close = 'close',
  CloseOutlined = 'close-outlined',
  Clock = 'clock',
  Clipboard = 'clipboard',
  ChevronUp = 'chevron-up',
  ChevronRight = 'chevron-right',
  ChevronLeft = 'chevron-left',
  ChevronDown = 'chevron-down',
  Check = 'check',
  CheckOutlined = 'check-outlined',
  Chat = 'chat',
  ChatTemplate = 'chat-template',
  ChartPie = 'chart-pie',
  ChartLine = 'chart-line',
  ChartBar = 'chart-bar',
  Camera = 'camera',
  Calendar = 'calendar',
  Bus = 'bus',
  BurgerMenu = 'burger-menu',
  BurgerMenuReduce = 'burger-menu-reduce',
  BurgerMenuExpand = 'burger-menu-expand',
  Bubbletub = 'bubbletub',
  Board = 'board',
  Bling = 'bling',
  Blinders = 'blinders',
  Bike = 'bike',
  Bidet = 'bidet',
  BellFilled = 'bell-filled',
  Bed = 'bed',
  Bathtub = 'bathtub',
  Basement = 'basement',
  BarrierFree = 'barrier-free',
  Balcony = 'balcony',
  Attic = 'attic',
  ArrowUp = 'arrow-up',
  ArrowRight = 'arrow-right',
  ArrowLeft = 'arrow-left',
  ArrowDown = 'arrow-down',
  Armchair = 'armchair',
  Area = 'area',
  Archive = 'archive',
  Application = 'application',
  AirCondition = 'air-condition',
}
